export const AGREEMENTS_QUERY_KEY = {
  AGREEMENTS: 'agreements',
  AGREEMENT_NOTES: 'agreement_notes',
  AGREEMENT_FILE: 'agreement_file',
  AGREEMENT_HISTORY: 'agreement_history',
}
